import React from "react";

const WireAccountDetails = ({wireAccount, accountNumber}) => {

    return <div className="row">
                <div className="col-12">
                    {/* <!--begin::List Widget 14--> */}
                    <div className="card card-custom gutter-b">
                        {/* <!--begin::Header--> */}
                        <div className="card-header border-0">
                            <h3 className="card-title font-weight-bolder text-dark">Wire Account Details</h3>
                        </div>
                        {/* <!--end::Header--> */}
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-2">
                            {/* <!--begin::Item--> */}
                            <div className="row">
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Number</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.accountNumber}</span>
                                </div>
                                {/* <!--end::Field--> */}
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Beneficiary Name</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.beneficiaryName}</span>
                                </div>
                                {/* <!--end::Field--> */}
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Bank Name</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.bankName}</span>
                                </div>
                                {/* <!--end::Field--> */}
                            </div>
                            <div className="row">
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Swift Code</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.swiftCode}</span>
                                </div>
                                {/* <!--end::Field--> */}

                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Routing Number</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.routingNumber}</span>
                                </div>
                                {/* <!--end::Field--> */}
                                
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Bank Address</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.bankAddress}</span>
                                </div>
                                {/* <!--end::Field--> */}
                            </div>
                            {/* <!--end::Item--> */}
                            <div className="row">
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3 col-md">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Instruction</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1">{wireAccount?.instructions?.replace("[Trading Account Number Here]", accountNumber)} If the wire is coming from a third party we will need a Letter of Authorization from the third party stating the intention of the wire.</span>
                                </div>
                                {/* <!--end::Field--> */}
                            </div>
                            {/* <!--end::Item--> */}
                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::List Widget 14--> */}
                </div>

            </div>


}

export default WireAccountDetails;